export const LAUNCH_APP = 'https://app.dual.finance/';
export const DISCORD = 'https://discord.gg/P3uH9AvEp5';
export const MEDIUM = 'https://medium.com/@dualfinance';
export const TWITTER = 'https://twitter.com/DualFinance';
export const INSTAGRAM = 'https://www.instagram.com/dual.finance/?hl=en';
export const DOCS = 'https://dual-finance.gitbook.io/dual-finance-documentation/';
export const REALMS = 'https://app.realms.today/realm/dual%20dao/hub';
export const GITHUB = 'https://github.com/Dual-Finance';
export const PARTNER_FORM = 'https://forms.gle/kQuQ8edzDxBQTExEA';
